import { addDays, format as formatDate, isValid } from 'date-fns';
import { isOrdinalLanguage, Logger } from 'wtb-utils';

const getRegretDate = (date, locale, localeObject, cancellationDays = 0) => {
  const newDate = addDays(new Date(date), cancellationDays);
  const dateFormat = isOrdinalLanguage(locale) ? 'do MMMM yyyy' : 'dd MMMM yyyy';
  const options = { locale: localeObject };

  if (isValid(newDate)) {
    return formatDate(newDate, dateFormat, options);
  } else {
    Logger.error(`${newDate } is not a valid date`);
    return '';
  }
};

export default getRegretDate;
